// Index file for the directory. Don't add anything else here.
import CarouselDiscovery from './CarouselDiscovery';
export default CarouselDiscovery;
